import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import Layout from './components/Layout';
import Home from './pages/Home';
import Login from './pages/Login';
import Register from './pages/Register';
import ResetPassword from './pages/ResetPassword';
import Courses from './pages/Courses';
import CourseDetail from './pages/CourseDetail';
import MyCourses from './pages/MyCourses';
import MyApplications from './pages/MyApplications';
import InstructorDashboard from './pages/InstructorDashboard';
import CourseManager from './pages/CourseManager';
import UserManagement from './pages/UserManagement';
import useAuthStore from './store/authStore';
import ErrorBoundary from './components/ErrorBoundary';

// 受保护的路由
const ProtectedRoute = ({ children, requireInstructor = false }) => {
  const { isAuthenticated, user } = useAuthStore();
  
  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }
  
  if (requireInstructor && user?.role !== 'instructor' && user?.role !== 'admin') {
    return <Navigate to="/" />;
  }
  
  return children;
};

// 内部组件，使用 useNavigate
const AppContent = () => {
  const { init } = useAuthStore();
  const navigate = useNavigate();

  useEffect(() => {
    init();
    
    // 监听认证错误事件，使用 React Router 导航而不是 window.location.href
    const handleAuthError = () => {
      localStorage.removeItem('token');
      localStorage.removeItem('deviceId');
      navigate('/login');
    };

    window.addEventListener('auth-error', handleAuthError);
    return () => window.removeEventListener('auth-error', handleAuthError);
  }, [init, navigate]);

  return (
    <>
      <Toaster position="top-center" />
      <Layout>
        <ErrorBoundary>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/courses" element={<Courses />} />
            <Route path="/courses/:id" element={<CourseDetail />} />
            <Route
              path="/my-courses"
              element={
                <ProtectedRoute>
                  <MyCourses />
                </ProtectedRoute>
              }
            />
            <Route
              path="/my-applications"
              element={
                <ProtectedRoute>
                  <MyApplications />
                </ProtectedRoute>
              }
            />
            <Route
              path="/instructor"
              element={
                <ProtectedRoute requireInstructor>
                  <InstructorDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/instructor/courses/:id"
              element={
                <ProtectedRoute requireInstructor>
                  <CourseManager />
                </ProtectedRoute>
              }
            />
            <Route
              path="/instructor/users"
              element={
                <ProtectedRoute requireInstructor>
                  <UserManagement />
                </ProtectedRoute>
              }
            />
          </Routes>
        </ErrorBoundary>
      </Layout>
    </>
  );
};

function App() {
  return (
    <Router basename="/learn">
      <AppContent />
    </Router>
  );
}

export default App;
